import { withBlockExtensions } from '@plone/volto/helpers/Extensions';

import CardsBody from './CardsBody';

const View = (props) => <CardsBody {...props} />;

export default withBlockExtensions(View);
